/// <amd-module name="Tfs/Header/Components/Components/FpsLoading/FpsLoading" />
import React = require("react");

import { Spinner, SpinnerSize } from "VSSUI/Spinner";

import { Callout, ContentJustification, ContentLocation, ContentOrientation } from "VSSUI/Callout";

import { FastPageSwitchEvent, FastPageSwitchEventCompletedDetail, FastPageSwitchEventLoadingDetail } from "VSS/Platform/Context";
import { VssComponent } from "VSS/Platform/Layout";

import * as Resources from "Tfs/Header/Components/Resources";
import { IFpsLoadingComponentProps } from "./FpsLoading.Props";

export interface IFpsLoadingComponentState {
    showLoadingIndicator?: boolean;
}

export class FpsLoadingComponent extends VssComponent<IFpsLoadingComponentProps, IFpsLoadingComponentState> {
    private static preProgressDelay = 500;

    private lastLoadingEvent: FastPageSwitchEventLoadingDetail | undefined;
    private loadingDelayTimeout: number;

    constructor(props: IFpsLoadingComponentProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element | null {
        if (!this.state.showLoadingIndicator) {
            return null;
        }

        return (
            <Callout
                className="fps-loading-content-layer"
                contentClassName="fps-loading-content font-size-m"
                contentLocation={ContentLocation.Center}
                contentJustification={ContentJustification.Center}
                contentOrientation={ContentOrientation.Column}
                modal={true}
            >
                <Spinner label={Resources.Loading} size={SpinnerSize.large} />
            </Callout>
        );
    }

    public componentDidMount(): void {
        super.componentDidMount();

        this.addEventListener(document.body, "fpsLoading", this.onFpsLoading);
        this.addEventListener(document.body, "fpsCompleted", this.onFpsCompleted);
    }

    private onFpsLoading = (loadingEvent: FastPageSwitchEvent<FastPageSwitchEventLoadingDetail>) => {
        this.lastLoadingEvent = loadingEvent.detail;
        if (!this.loadingDelayTimeout) {
            this.loadingDelayTimeout = this.setTimeout(() => {
                this.setState({ showLoadingIndicator: true });
                this.loadingDelayTimeout = 0;
            }, FpsLoadingComponent.preProgressDelay);
        }
    };

    private onFpsCompleted = (completedEvent: FastPageSwitchEvent<FastPageSwitchEventCompletedDetail>) => {
        if (this.lastLoadingEvent && this.lastLoadingEvent.data === completedEvent.detail.data) {
            this.lastLoadingEvent = undefined;
            if (this.loadingDelayTimeout) {
                this.clearTimeout(this.loadingDelayTimeout);
            }
            if (this.state.showLoadingIndicator) {
                this.setState({ showLoadingIndicator: false });
            }
        }
    };
}

VssComponent.register("fpsLoading", FpsLoadingComponent);
